// transform color titles into CSS class names as defined in custom.css.liquid for swatches
export function colorKey(colorTitle) {
  return colorTitle.trim().replace(/ /g, '_');
}

/**
* Todo: Implement all this logic in custom element.
* Load siblings from algolia data as well, instead of slow Shopify section API and liquid snippets.
*/

export function imageElement(image, alt, fit = 'contain', eager = false) {
  let picture = '';
  const aspect = (100 / 0.8079)+'%';
  if (image) {
    const widths = [125, 150, 175, 200, 250, 300, 350, 400, 450]
    const srcSet = widths.map(w => image.url + (image.url.includes('?')?'&':'?') + 'width=' + w + ' ' + w + 'w').join(',');
    const sizes = `(max-width: 320px) 44vw,
                  (max-width: 750px) 47vw,
                  (max-width: 1200px) 36vw,
                  (max-width: 1600px) 24vw,
                  calc(min(22vw, 450px))`;
    picture = `<picture class="w-full h-full absolute ${fit || 'contain'}">
      <source srcset="${srcSet}" sizes="${sizes}">
      <img${eager ? '' : ' loading="lazy"'} alt="${alt}" width="${image.width}" height="${image.height}" class="w-full h-full" onload="this.closest('product-grid-item').classList.remove('loading')">
    </picture>`;
  }
  const res = `<div class="picture-wrapper flex flex-col relative" style="--aspect-ratio: ${aspect}">
    ${picture}
  </div>`;
  return res;
}

export function productBadges(product, variant) {
  if (!variant.available) {
    return `
      <div class="product-badges product-badges__top-right absolute top-0 right-0 flex flex-col justify-start items-end">
        <div class="product-badge sold-out relative inline-flex flex-row items-center justify-center gap-2">
          ${product.coming_soon || product.tags.includes('NOS') ? window.Shopify.translations['product.coming_soon'] : window.Shopify.translations['product.sold_out']}
        </div>
      </div>
    `;
  } else {
    const price = variant[`price_${Shopify.currency.active}`];
    const compareAtPrice = variant[`compareAtPrice_${Shopify.currency.active}`];
    //console.log(product.handle, { price, compareAtPrice, reduced: (compareAtPrice - price)/compareAtPrice > 0.05 }, product);
    
    const badges = product.badges?.filter(b => b.show_on === 'ProductCards' || b.show_on === 'Both' || !b.show_on)/*.filter(b => product.collections.includes('golden-week') ? b.text_en.toLowerCase().includes('golden') : true)*/ || [];
    let badgesTopLeft = badges.filter(b => b.position === 'top-left').sort((a, b) => a.order - b.order) || [];
    let badgesTopRight = badges.filter(b => b.position === 'top-right').sort((a, b) => a.order - b.order) || [];
    let badgesBottomLeft = badges.filter(b => b.position === 'bottom-left').sort((a, b) => a.order - b.order) || [];
    let badgesBottomRight = badges.filter(b => b.position === 'bottom-right').sort((a, b) => a.order - b.order) || [];
    if ((compareAtPrice - price)/compareAtPrice > 0.05) {
      badgesTopRight.unshift(`
          <div class="product-badge on-sale relative inline-flex flex-row items-center justify-center gap-2">
            -${Math.round(100*(compareAtPrice - price)/compareAtPrice)}%
          </div>`
      );
    }

    const hurryEnabled = product.hurryEnabled;
    let showHurry = false;
    if (hurryEnabled) {
      const hurryOnTime = product.hurryOnTime && new Date(product.hurryOnTime);
      const hurryOffTime = product.hurryOffTime && new Date(product.hurryOffTime);
      const now = new Date();
      showHurry = !hurryOnTime && !hurryOffTime || hurryOnTime && hurryOffTime && now < hurryOffTime && now >= hurryOnTime || hurryOnTime && !hurryOffTime && now >= hurryOnTime || hurryOffTime && !hurryOnTime && now < hurryOffTime;
    }

    showHurry = showHurry || (product.quantityAvailable < Shopify.theme.settings.hurry_up_limit);
    showHurry = showHurry || product.tags.includes('hurry_up');
    showHurry = showHurry && !product.tags.includes('no_hurry_up');

    if (false && showHurry) {
      badgesBottomRight.unshift(`
        <div class="product-badge hurry relative inline-flex flex-row items-center justify-center gap-2">
        <div class="svg-icon svg-icon--bolt"></div>
        <span class="p bold px-1 hurry_badge_text">
          ${ product.quantityAvailable < Shopify.theme.settings.hurry_up_with_amount_limit ? window.Shopify.translations['product.availability.only_few_short_with_amount'].replace('[count]', product.quantityAvailable) : window.Shopify.translations['product.availability.only_few_short'] }
        </span>
      </div>
      `);
    }

    const bclasses = {
      badgesTopLeft: 'product-badges__top-left top-0 left-0 justify-start items-start',
      badgesTopRight: 'product-badges__top-right top-0 right-0 justify-start items-end',
      badgesBottomLeft: 'product-badges__bottom-left bottom-0 left-0 justify-end items-start',
      badgesBottomRight: 'product-badges__bottom-right bottom-0 right-0 justify-end items-end'
    };
    return Object.entries({ badgesTopLeft, badgesTopRight, badgesBottomLeft, badgesBottomRight }).map(([k, badges]) => {
      if (badges.length) {
        return `
          <div class="product-badges flex flex-col absolute ${bclasses[k]}">
            ${badges.map(
              badge => typeof badge === 'string' ? badge : `
                <div class="product-badge ${badge.shape} relative inline-flex flex-row items-center justify-center gap-2" style="color: ${badge.color}; background-color: ${badge.background_color}">
                  ${badge.shape === 'circle' ? `<div class="absolute flex flex-col justify-center items-center text-center">` : ''}
                    ${badge.text && `<span>${badge[`text_${Shopify.locale}`] || badge.text}</span>` || ''}
                    ${badge.icon && `<span ${badge.color ? ` data-svg-color="${badge.color}"` : ''} class="svg-icon svg-icon--${badge.icon}"></span>` || ''}
                  ${badge.shape === 'circle' ? `</div>` : ``}
                </div>
              `
            ).join('')}
          </div>
        `;
      }
      return '';
    }).join('\n');
  }
}
window.algoliaHits = window.algoliaHits || {};
export function transformHit(product, options) {
  product.id = product.objectID;
  const eager = options && (options.eager || typeof options !== 'object');
  const hasATC = true || options && options.hasATC;
  const algoliaHit = window.algoliaHits && window.algoliaHits[product.handle];
  if (algoliaHit && algoliaHit.markup) {
    let res = algoliaHit.markup.replace('[hasATC]', hasATC ? ' has-atc="true"' : '').replace('[addClass]', `${options?.addClass ? ' ' + options.addClass : ''}${eager ? '' : ' loading'}`).replace('[atcJ]', hasATC ? algoliaHit.atcJ : '').replace('[atcM]', hasATC ? algoliaHit.atcM : '').replace('[atcD]', hasATC ? algoliaHit.atcD : '');
    return res;
  }
  const availableVariants = product.variants.filter(v => v.available);
  product.availableVariants = availableVariants;
  const firstAvailableVariant = product.variants.find(v => v.available);
  const variant = firstAvailableVariant || product.variants[0];
  const soldOut = !variant.available;
  const onSale = variant.onSale;
  const domId = `product-grid-item-${product.id || product._id || product.objectID}--${Date.now()}`;
  const title = product[`family_${Shopify.locale}`] || product.family || product[`title_${Shopify.locale}`] || product.title;
  const siblings = [];
  const domain = location.host.split('.')[0].replace('paul-valentine-hc-eur', 'www').replace('paul-valentine', 'www');
  if (product.siblings) {
    product.siblings = product.siblings.filter(sibling => sibling.publishedInMarkets && sibling.publishedInMarkets.includes(domain));
    for (const sibling of product.siblings) {
      if (siblings.length === 4) {
        break;
      }
      if (sibling.available || product.tags.includes('AK24')) {
        siblings.push(sibling);
      }
    }
    for (const sibling of product.siblings) {
      if (siblings.length === 4) {
        break;
      }
      if (!sibling.available && sibling.nos) {
        siblings.push(sibling);
      }
    }
  }
  const atcJ = `
    <script data-product type="application/json">
      ${JSON.stringify(product)}
    </script>
    `;
  const atcD = !soldOut ? `
        <div class="cursor-pointer absolute svg-icon svg-icon--qatc"></div>
        <div class="cursor-pointer absolute svg-icon svg-icon--qatc-check"></div>
  ` : '';
  const moreSiblings = product.siblings && product.siblings.length && Math.max(0, product.siblings.length - 4) || 0;
  const res = `<product-grid-item id="${domId}" link="/products/${product.handle}" class="flex flex-col${soldOut? ' sold-out':''}${product.rolloverImage ? ' has-rollover' : ''}[addClass]"[hasATC]>[atcJ]
    <div class="relative product-grid-item__images${product.rolloverImage ? ' has-rollover' : ''}">` +
      (product.image ? `
        <a href="/products/${product.handle}" class="product-grid-item__image">
          ${imageElement(product.image, title, 'contain', eager)}
        </a>` : ''
      ) + (product.rolloverImage ? `
        <a href="/products/${product.handle}" class="absolute bottom-0 left-0 w-full h-full rollover_image">
          ${imageElement(product.rolloverImage, title, 'cover')}
        </a>` : ''
      ) + `[atcD]
      ${productBadges(product, variant)}
    </div>
    <div class="relative flex flex-col items-start pt-2 sm+:mb-6 w-full h-full product-grid-item__content${onSale ? ' on_sale' : ''}">
      <a href="/products/${product.handle}" class="product-grid-item__title sm+:pt-1 pb-2 text-align-left">
        ${title}
      </a>
      ${productPrice(variant)}
      <div class="price-sibling-wrapper flex flex-col items-start">
        <div class="product-grid-item__siblings flex flex-row items-center py-1 gap-2">
          ` + (product.siblings ? siblings.map(sibling => `<clever-sibling
            type="grid-item"
            replace="${domId}"
            sibling-url="/products/${sibling.handle}"
            sibling-handle="${sibling.handle}"
            class="flex swatch sibling-swatch${sibling.primaryColor ? ' swatch-primary-'+colorKey(sibling.primaryColor) : ''}${sibling.secondaryColor ? ' swatch-secondary-'+colorKey(sibling.secondaryColor) : ''} ${!sibling.available ? 'sold_out ' : ''} ${sibling.id === product.id ? 'current' : ''}"
          ></clever-sibling>`).join('\n') + (moreSiblings ? `<p class="note">+${moreSiblings}</p>` : '') : `<button
            aria-label="${title}"
            class="swatch sibling-swatch${product.primaryColor ? ' swatch-primary-'+colorKey(product.primaryColor) : ''}${product.secondaryColor ? ' swatch-secondary-'+colorKey(product.secondaryColor) : ''} current${soldOut ? ' sold_out' : ''}"
          ></button>`) + `
        </div>
      </div>
    </div>
  </product-grid-item>`;
  product.markup = res;
  product.atcJ = atcJ;
  product.atcD = atcD;
  window.algoliaHits[product.handle] = product;
  return res
    .replace('[atcJ]', hasATC ? atcJ : '')
    .replace('[atcD]', hasATC ? atcD : '')
    .replace('[hasATC]', hasATC ? ' has-atc="true"' : '')
    .replace('[addClass]', `${options?.addClass ? ' ' + options.addClass : ''}${eager ? '' : ' loading'}`);
};
window.transformHit = transformHit;
